import styled from "styled-components/macro";

export const SelectContainer = styled.div(
  ({ theme, minWidth, maxWidth, spacing }) => ({
    display: "flex",
    flexDirection: "column",
    minWidth: minWidth.mobile,
    maxWidth: maxWidth,

    "> *": {
      marginBottom: spacing,
      "&:last-child": {
        marginBottom: 0,
      },
    },

    [theme.breakpoint.md()]: {
      minWidth: minWidth.desktop,
    },
  })
);

export const Input = styled.div(
  ({ theme, half, selectOnly, width = "100%", noMinWidth }) => ({
    display: "flex",
    alignItems: "center",
    zIndex: "initial",
    position: "relative",
    userSelect: "none",
    width: "100%",

    input: {
      cursor: selectOnly && "pointer",
    },

    [theme.breakpoint.lg()]: {
      maxWidth: half && "50%",
      minWidth: !noMinWidth && "300px",
      width,
    },

    div: {
      flexGrow: 1,
    },

    ul: {
      top: "86px",
      left: 0,
      zIndex: 9,
    },

    ".loading-spinner": {
      position: "absolute",
      right: "16px",
      top: "calc(50% + 6px)",
      width: "16px",
      height: "16px",

      div: {
        borderColor: `${theme.color.brandPrimary.light} transparent transparent transparent`,
        borderWidth: "3px",
        width: "16px",
        height: "16px",
      },
    },

    ".carret": {
      position: "absolute",
      top: "48px",
      right: "10px",
      pointerEvents: "none",
      color: theme.color.brandPrimary.light,
    },
  })
);

export const IconContainer = styled.div(
  ({ spacing, iconSize, iconColor, parentHeight }) => ({
    position: "absolute",
    right: spacing,
    top: `calc(((${parentHeight} - ${iconSize}) / 2) + 2px )`,
    width: iconSize,
    height: iconSize,

    svg: {
      position: "relative",
      path: {
        fill: iconColor,
      },
    },
  })
);

export const OptionItem = styled.li`
  list-style: none;
  width: calc(100% - 12px - 12px);
  min-height: calc(40px - 8px - 8px);
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 12px;
  padding-right: 12px;
  background-color: #ffffff;
  border-bottom: 1px solid #c6c2c5;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.color.brandPrimary.light};
    color: ${({ theme }) => theme.color.neutral["08"]};
  }
`;

export const OptionList = styled.ul`
   {
    position: absolute;
    padding: 0;
    margin: 0;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px -2px 2px rgb(40 46 46 / 5%), 0px 6px 8px rgb(40 46 46 / 16%);
    max-height: 200px;
    overflow-y: auto;
    top: 43px;
    left: 0;
    z-index: 9;
    & > li {
      width: 100%;
    }
  }
`;
